riot.tag2('checkout-item', '<div class="co-panel"> <h2>Objekt</h2> <div class="co-content"> <figure class="co-table-cell"> <img riot-src="{model.imageUrl}" alt="{model.title}" title="{model.title}"> </figure> <div class="co-table-left">{model.title}</div> <div class="co-table-right">{model.price}&nbsp;kr</div> </div> </div> <div class="co-panel-divider"></div>', '', '', function(opts) {
        this.model = opts.model;

        this.on('mount', function () {
            //alert('shipping mounted: ' + opts.data);
        });
});


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-item.riot.html